import { Shape } from "./shape";

export class teamPlatform extends Shape{
    
    override width: number = 300;
    override height: number = 25;
    override rx: number = 2.5;
    override ry: number = 2.5;
    override color: string = "#b7cdf2";
    override strokeColor: string = "#6d9be2";
    override strokeDashArray: [number, number] = [0 ,0];
    
    

    constructor() {
        super();    
    }

}